import { FormikProps } from 'formik';
import { Dataset, PrivacyLinkObject } from '~/src/root.types';

export enum FormName {
  FIRST_NAME = 'first-name',
  LAST_NAME = 'last-name',
  EMAIL = 'email',
  COUNTRY = 'country',
  COMPANY = 'company',
  INDUSTRY = 'industry',
  MAU = 'mau',
  PHONE = 'phone',
  PUSHWOOSH_PRIVACY = 'pushwoosh-privacy',
  PARTNER_PRIVACY = 'partner-privacy',
  RECAPTCHA_RESPONSE = 'recaptchaResponse',
}

export type FormValues = {
  [FormName.FIRST_NAME]: string;
  [FormName.LAST_NAME]: string;
  [FormName.EMAIL]: string;
  [FormName.COUNTRY]: string;
  [FormName.COMPANY]: string;
  [FormName.INDUSTRY]: string;
  [FormName.MAU]: string;
  [FormName.PHONE]: string;
  [FormName.PUSHWOOSH_PRIVACY]: boolean;
  [FormName.PARTNER_PRIVACY]: boolean;
  [FormName.RECAPTCHA_RESPONSE]: string;
};

export type FormProps = Omit<JSX.IntrinsicElements['div'], 'ref'> & {
  readonly [Dataset.BUTTON_TEXT]: string;
  readonly [Dataset.FOOTNOTE_TEXT]: string;
  readonly [Dataset.ENABLE_PARTNER_PRIVACY]: boolean;
  readonly [Dataset.ENABLE_MAU]: boolean;
  readonly [Dataset.MIXPANEL_ATTRIBUTE]: string;
  readonly [Dataset.METRIC_EVENT]: string;
  readonly [Dataset.HIDE_PHONE]: boolean;
  readonly [Dataset.SOURCE]: string;
  readonly form: FormikProps<FormValues>;
  readonly partnerPrivacyLinkList: Array<PrivacyLinkObject>;
};
